<template>
    <div id="user-edit-tab-info">

      <!-- Content Row -->
      <div class="vx-row">
        <div class="vx-col w-full">

          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Datos personales</span>
            </div>
            <vs-divider />
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" label="Nombre" v-model="data_local.name" v-validate="'required|alpha_spaces'" name="name" autofocus autocomplete="off"/>
            <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

            <vs-input class="w-full mt-4" label="Apellido" v-model="data_local.last_name" v-validate="'required|alpha_spaces'" name="last_name" autocomplete="off"/>
            <span class="text-danger text-sm"  v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>

            <div class="mt-4 flex flex-wrap">
              <div class="w-1/2">
                <vs-input class="w-full" label="Email" :disabled="true" v-model="data_local.email" type="email" v-validate="'required|email'" name="email" autocomplete="off"/>
                <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
              </div>
              <div class="w-1/2">
                <vs-input label="Teléfono" class="w-full pl-4" v-model="data_local.phone_number" name="phone_number" placeholder="Número de teléfono" autocomplete="off"/>
                <span class="text-danger text-sm"  v-show="errors.has('phone_number')">{{ errors.first('phone_number') }}</span>
              </div>
            </div>

            <div class="mt-4 flex flex-wrap">
              <label class="vs-input--label w-full">Documento de identidad</label>
              <div class="w-1/2">
                <v-select
                  :disabled="!!data_local.card_type_id"
                  v-model="data_local.card_type_id"
                  :reduce="card_type_id => card_type_id.card_type_id"
                  :options="cardTypeOptions"
                  :clearable="false"
                  v-validate="'required'"
                  name="card_type_id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :searchable="false"
                />
              </div>
              <span class="text-danger text-sm"  v-show="errors.has('card_type_id')">{{ errors.first('card_type_id') }}</span>
              <div class="w-1/2 pl-4">
                <vs-input
                  :disabled="data_local.card_id || data_local.card_id !== ''"
                  class="w-full"
                  v-model="data_local.card_id"
                  v-validate="'max:15'"
                  name="card_id"
                  placeholder="Número"
                  autocomplete="off"
                />
                <span class="text-danger text-sm"  v-show="errors.has('card_id')">{{ errors.first('card_id') }}</span>
              </div>
            </div>

            <div class="mt-4">
              <label>Fecha de nacimiento</label>
              <div class="flex flex-wrap">
                <datepicker :disabledDates="disabledDates" :useUtc="true" :openDate="openDate" :format="dateFormat" v-model="birthdayLocal" v-validate="'required'" name="birthday_date"></datepicker>
                <span class="text-danger text-sm"  v-show="errors.has('birthday_date')">{{ errors.first('birthday_date') }}</span>
              </div>
            </div>

            <div class="mt-4 flex flex-wrap">
              <vs-input class="w-1/2" label="Dirección" v-model="data_local.address" name="address"  autocomplete="off"/>
              <span class="text-danger text-sm"  v-show="errors.has('address')">{{ errors.first('address') }}</span>
              <vs-input class="w-1/4 pl-4" label="Ciudad" v-model="data_local.city" name="city" placeholder="Ciudad" autocomplete="off"/>
              <span class="text-danger text-sm"  v-show="errors.has('city')">{{ errors.first('city') }}</span>
              <vs-input class="w-1/4 pl-4" label="Código Postal" v-model="data_local.zip_code" name="zip_code" placeholder="Código Postal" autocomplete="off"/>
              <span class="text-danger text-sm"  v-show="errors.has('zip_code')">{{ errors.first('zip_code') }}</span>
            </div>
          </div>

          <!-- <div class="vx-col mt-12">
            <div class="vx-col w-full">
              <div class="flex items-end px-3">
                <span class="font-medium text-lg leading-none">Estudiantes relacionados</span>
              </div>
              <vs-divider />
            </div>

            <div class="flex flex-col">
              <label class="vs-input--label w-full">Documento de identidad</label>
              <div class="flex">
                <div class="w-1/2">
                  <v-select
                    browserAutocomplete="off"
                    autocomplete="off"
                    v-model="student_data.id_document_type"
                    :reduce="id_document_type => id_document_type.card_type_id"
                    :options="cardTypeOptions"
                    :clearable="false"
                    name="id_document_type"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :searchable="false"
                  />
                </div>
                <div class="w-1/2 pl-4">
                  <vs-input
                    class="w-full"
                    v-model="student_data.document"
                    autocomplete="off"
                    v-validate="'max:15'"
                    name="document"
                    placeholder="Número"
                    data-vv-as="Número de Documento"/>
                </div>
                <div class="flex pl-4">
                  <vs-button color="primary" @click="addStudent">Agregar</vs-button>
                </div>
              </div>
            </div>
          </div> -->
          <parent-related-students :data="studentsData" @updateStudentsData="updateStudensData"/>
        </div>
      </div>
      <!-- <ag-grid-vue
        class="ag-theme-material w-100 my-4 ag-grid-table"
        ref="agGridTable"
        :columnDefs="columnDefs"
        :rowData="studentsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :enableRtl="$vs.rtl"
        :modules="modules"
      /> -->

      <!-- Save & Reset Button -->
      <div class="vx-row mt-12">
        <div class="vx-col w-full mt-12">
          <div class="mt-12 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Guardar</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import Datepicker from 'vuejs-datepicker';
  import vSelect from 'vue-select'
  import ParentRelatedStudents from '../components/ParentRelatedStudents.vue';
  import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
  import { AgGridVue } from "@ag-grid-community/vue"
  import {AllCommunityModules} from '@ag-grid-community/all-modules';
  import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
  import CellRendererActions from '../cell-renderer/CellRendererActions.vue';

  import UserFunctions from '../UserFunctions';


  export default {
    mixins: [UserFunctions],
    components: {
      Datepicker,
      'v-select': vSelect,
      AgGridVue,
      CellRendererActions,
      ParentRelatedStudents
    },
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        data_local: {},
        modules: AllCommunityModules,
        student_data: {
          id_document_type: '',
          document: '',
        },
        studentsData: JSON.parse(JSON.stringify(this.data.pupils)) || [],
        cardTypeOptions: [],

        disabledDates: {
          from: new Date(new Date().getFullYear()-16, new Date().getMonth(), new Date().getDay()),
        },
        openDate: new Date(new Date().getFullYear()-18, new Date().getMonth(), new Date().getDay(), 12, 0, 0),
        dateFormat: "dd-MM-yyyy",
        columnDefs: [
          {
            headerName: 'Document',
            field: 'document',
            width: 150,
            filter: false,
          },
          {
            headerName: 'Nombre',
            field: 'full_name',
            filter: false,
            width: 300,
          },
          {
            headerName: 'Escuela',
            field: 'school_name',
            filter: false,
            width: 250,
          },
          {
            headerName: 'Accion',
            cellRendererFramework: 'CellRendererActions',
            cellRendererParams: {
              onDelete: this.removeStudent,
            },
          },
        ],
        defaultColDef: {
          sortable: true,
          resizable: false,
          suppressMenu: true
        },
      }
    },
    computed: {
      birthdayLocal: {
        get() {
          return this.$isDate(this.data_local.birthday_date) ? this.data_local.birthday_date.toISOString().split("T")[0] : this.data_local.birthday_date.split("T")[0]
        },
        set(val) {
          this.data_local.birthday_date = val.toISOString().split("T")[0]
        }
      },
      validateForm() {
        return !this.errors.any() && this.data_local.card_type_id
      }
    },
    methods: {
      updateStudensData(students) {
        console.log('updateStudentsData', students)
        this.studentsData = students
      },
      save_changes() {
        if (!this.validateForm) return

        this.data_local.birthday_date = this.$isDate(this.data_local.birthday_date) ? this.data_local.birthday_date.toISOString().split("T")[0] : this.data_local.birthday_date.split("T")[0]
        const data = this.getFormData(this.data_local, this.studentsData)
        this.$store.dispatch('userManagement/updateParent', data).then(response => {
          if (response.status && response.msg === '') {
            this.showNotify('success', 'Correcto!', 'Se actualizó la información del acudiente')
            this.redirectToUsers()
          } else {
            this.showNotify('danger', 'Error', response.msg)
          }
        }).catch(error => {
          console.error(error)
          this.showNotify('danger', 'Error', error || 'Ocurrió un error al actualizar la información del acudiente')
        })
      },
      reset_data() {
        if (
          JSON.stringify(this.data_local) === JSON.stringify(this.originalData)
          && this.studentsData.length === this.data.pupils.length
        ) {
          this.redirectToUsers()
          return
        }
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Cancelar',
          text: '¿Estás seguro que deseas cancelar? Se perderán los cambios realizados',
          acceptText: 'Si',
          accept: this.redirectToUsers,
        })
      },
      showNotify(type,title,text) {
        this.$vs.notify({
          color: type || 'success',
          title: title || 'Correcto!',
          text: text || '',
          time: 8000,
          position: 'top-center',
        })
      },
    },
    created() {
      this.data_local = {
        ...JSON.parse(JSON.stringify(this.data || {})),
        avatar: 0,
        birthday_date: this.data && this.data.birthday_date ? new Date(this.data.birthday_date) : null,
      }
      this.originalData = JSON.parse(JSON.stringify(this.data_local))
      this.cardTypeOptions = this.$store.state.AppData.cardTypes
      if(!moduleUserManagement.isRegistered) {
        this.$store.registerModule('userManagement', moduleUserManagement)
        moduleUserManagement.isRegistered = true
      }
    }
  }
  </script>
